import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Box,
  AppBar,
  useMediaQuery,
  Toolbar,
  styled,
  Stack,
  Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from 'react-redux';
import {
  toggleSidebar,
  toggleMobileSidebar,
  setDarkMode,
  toggleLayout,
} from 'src/store/customizer/CustomizerSlice';
import { IconMenu2 } from '@tabler/icons';

// components

import Profile from './vertical/header/Profile';

import SunModeAnimation from 'src/assets/animations/sun.json';
import MoonModeAnimation from 'src/assets/animations/moon.json';
import Lottie from 'lottie-react';

import AspectRatioTwoToneIcon from '@mui/icons-material/AspectRatioTwoTone';
import CallToActionTwoToneIcon from '@mui/icons-material/CallToActionTwoTone';
// import Brand from 'src/assets/main-brand/Screenshot 2024-07-19 161958.png';

import { GetUser } from 'src/hooks/useAuthentication';

const Header = () => {
  // for google button

  const user = GetUser();

  const lgxl = useMediaQuery((theme) => theme.breakpoints.up('xl'));
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  // drawer
  const customizer = useSelector((state) => state.customizer);
  const dispatch = useDispatch();
  const isLayoutRedux = useSelector((state) => state.customizer.isLayout);

  const StyledBox = styled(Box)(({ theme }) => ({
    // boxShadow: theme.shadows[8],
    padding: '2px',
    cursor: 'pointer',
    justifyContent: 'center',
    display: 'flex',
    transition: '0.1s ease-in',
    // border: '1px solid rgba(145, 158, 171, 0.12)',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  }));

  const AppBarStyled = styled(AppBar)(({ theme }) => ({
    boxShadow: '0px .1px 5px #000',
    // background: theme.palette.background.paper,
    background: customizer.activeMode === 'light' ? '#FFF2D7' : customizer.darkBackground900,
    // background: '#fff',
    justifyContent: 'center',
    backdropFilter: 'blur(4px)',
    [theme.breakpoints.up('lg')]: {
      minHeight: customizer.TopbarHeight,
    },
    // borderRadius: '0 0 1rem 1rem',
  }));
  const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
    width: '100%',
    color: theme.palette.text.secondary,
  }));

  // useEffect(() => {
  //   async function fetchData() {
  //     const notesData = await apiData('get', API.Notes);
  //     setNotificationCount(notesData.data.length);
  //   }
  //   fetchData();
  // }, []);

  const [selectedLayout, setSelectedLayout] = useState(() => {
    const storedLayout = localStorage.getItem('selectedLayout');
    return storedLayout || isLayoutRedux;
  });

  useEffect(() => {
    const storedLayout = localStorage.getItem('selectedLayout');
    if (storedLayout) {
      setSelectedLayout(storedLayout);
      dispatch(toggleLayout(storedLayout));
    }
  }, [dispatch]);

  const handleLayoutSelect = () => {
    const newLayout = selectedLayout === 'boxed' ? 'full' : 'boxed';
    setSelectedLayout(newLayout);
    dispatch(toggleLayout(newLayout));
    localStorage.setItem('selectedLayout', newLayout);
  };

  const StyledOptionBox = ({ selected, onClick, children }) => {
    const [hovered, setHovered] = useState(false);

    const handleMouseEnter = () => {
      setHovered(true);
    };

    const handleMouseLeave = () => {
      setHovered(false);
    };

    return (
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        padding={1}
        // border={selected ? '1px solid #3f51b5' : '1px solid transparent'}
        borderRadius={4}
        style={{
          cursor: 'pointer',
          color: '#fff',
          transform: hovered ? 'scale(1.05)' : 'scale(1)',
          transition: 'transform 0.3s ease',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={onClick}
        color={`#fff`}
      >
        {children}
      </Box>
    );
  };


  return (
    <AppBarStyled position="sticky" color="default">
      <ToolbarStyled>
        <IconButton
          // color="inherit"
          aria-label="menu"
          onClick={lgUp ? () => dispatch(toggleSidebar()) : () => dispatch(toggleMobileSidebar())}
          sx={{
            color: `${customizer.activeMode === 'light' ? '#5A72A0' : '#fff'}`,
            // color: '#fff',
          }}
        >
          <IconMenu2 size="20" />
        </IconButton>

        {/* <Search /> */}
        {lgUp && (
          <>
            <Box flexGrow={1} />
            {/* <div style={{ color: '#fff', fontSize: '18px', fontWeight: '500' }}>
              {!user?.company_name || user.company_name === ''
                ? lgUp && defaultCo
                : lgUp && user.company_name}
            </div> */}
            {/* <img src={Brand} height={"100px"} alt="brand logo"/> */}
          </>
        )}
        <Box flexGrow={1} />

        <Tooltip title="Sastraprakasika" arrow>
          <Box
            sx={{
              // border: '1px solid #fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* <img
              src={Brand}
              alt="New-logo"
              style={{
                width: lgUp ? '180px' : '140px',
                height: 'auto',
                marginRight: lgUp ? '40px' : '20px',
              }} */}
            {/* /> */}
          </Box>
        </Tooltip>

        <Stack spacing={1} direction="row" alignItems="center">
          {/* for small screen right side sidebar */}
          {/* {lgDown ? <MobileRightSidebar /> : null} */}

          {/* // -> Color Scheme icon */}
          <Stack direction={'row'} gap={2} my={2} sx={{ mx: 2 }}>
            <Tooltip
              title={`Change color scheme to ${
                customizer.activeMode === 'light' ? 'Dark' : 'Light'
              }`}
              arrow
            >
              <StyledBox
                onClick={() =>
                  dispatch(setDarkMode(customizer.activeMode === 'light' ? 'dark' : 'light'))
                }
                display="flex"
                gap={1}
              >
                {/* SunModeAnimation */}
                {customizer.activeMode === 'light' ? (
                  <Lottie
                    animationData={SunModeAnimation}
                    loop
                    autoplay
                    style={{ width: '40px', height: '40px' }}
                  />
                ) : (
                  <Lottie
                    animationData={MoonModeAnimation}
                    loop
                    autoplay
                    style={{ width: '40px', height: '40px' }}
                  />
                )}
              </StyledBox>
            </Tooltip>
          </Stack>

          {/* window mode */}
          {lgxl && (
            <Stack direction={'row'} gap={2} my={2} sx={{ mx: 2 }}>
              <StyledOptionBox selected={selectedLayout === 'boxed'} onClick={handleLayoutSelect}>
                {selectedLayout === 'boxed' ? (
                  <Tooltip title={`Change layout`} arrow>
                    <CallToActionTwoToneIcon
                      style={{ color: customizer.activeMode === 'light' ? '#ee9b00' : '#fff' }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={`Change layout`} arrow>
                    <AspectRatioTwoToneIcon
                      style={{ color: customizer.activeMode === 'light' ? '#ee9b00' : '#fff' }}
                    />
                  </Tooltip>
                )}
              </StyledOptionBox>
            </Stack>
          )}

          <Profile />
        </Stack>
      </ToolbarStyled>
    </AppBarStyled>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
  toggleSidebar: PropTypes.func,
};

export default Header;
